module.exports = __webpack_public_path__ + "a095a19f2c1395c60152ac6226fb668d.jpg";